(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-racing.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-racing.js');
"use strict";


const Image = svs.content.image_v2.Image;
const _svs$components$lbUti = svs.components.lbUtils.helpers.formatDate,
  getFormattedDate = _svs$components$lbUti.getFormattedDate,
  getFormattedTime = _svs$components$lbUti.getFormattedTime;
const DEFAULT_NUMBER_OF_DETAIL_LINES = 6;
const cdn = svs.core.config.data.svsconfig.cdn;
const getPixHandler = svs.components.sport.pixHandler.getPixHandler;
const HighFiveLogo = () => React.createElement("img", {
  alt: "High Five logotyp",
  className: "quickplay-modal-high-five-logo",
  src: "".concat(cdn, "/images/sport/quickplay-modal/high-five-logo.svg")
});
const ParticipantInfo = _ref => {
  let participants = _ref.participants,
    participantNumber = _ref.participantNumber,
    hasMoreInfo = _ref.hasMoreInfo,
    isReserve = _ref.isReserve;
  const participant = participants.find(item => item.number === participantNumber);
  if (isReserve) {
    return React.createElement(React.Fragment, {
      key: "reserve"
    }, React.createElement("div", null, React.createElement("span", {
      className: "btn-bet btn-bet-200 btn-bet-animated btn-bet-racing pix-btn-bet-racing btn-bet-selected pix-reserve pix"
    }, React.createElement("span", {
      className: "btn-bet-label"
    }, participantNumber))), Boolean(hasMoreInfo && participant) && React.createElement("div", {
      className: "reserve-horse-qp"
    }, participant.horseName));
  }
  return React.createElement("div", {
    className: "pix-selection"
  }, React.createElement("div", null, React.createElement("span", {
    className: "btn-bet btn-bet-200 btn-bet-racing pix-btn-bet-racing btn-bet-selected pix"
  }, React.createElement("span", {
    className: "btn-bet-label"
  }, participantNumber))), Boolean(hasMoreInfo && participant) && React.createElement("div", {
    className: "pix-participant-info"
  }, React.createElement("span", {
    className: "horse-info"
  }, participant.horseName), Boolean(participant.driverName) && React.createElement("div", {
    className: "driver-info"
  }, Boolean(participant.silkImageOptions) && React.createElement("div", {
    className: "driver-info-image"
  }, React.createElement(Image, {
    image: participant.silkImageOptions
  })), React.createElement("span", null, participant.driverName))));
};
const CouponRacing = _ref2 => {
  let raceData = _ref2.raceData,
    productId = _ref2.productId,
    isPixMix = _ref2.isPixMix;
  const isHighFive = raceData.isHighFive,
    closeTime = raceData.closeTime,
    trackName = raceData.trackName,
    raceNumber = raceData.raceNumber,
    participants = raceData.participants,
    raceName = raceData.raceName;
  const pixHandler = getPixHandler({
    isPixMix
  });
  const pixData = pixHandler.getModel(productId);
  const racingSigns = pixData || new Array(DEFAULT_NUMBER_OF_DETAIL_LINES).fill([]);
  const date = getFormattedDate(closeTime, true, true, true);
  const time = getFormattedTime(closeTime);
  const _turnSignsIntoListItem = (currSigns, index, allSigns) => {
    const isReserve = index === allSigns.length - 1;
    return React.createElement("div", {
      className: "pix-bet-summary-list-item",
      key: "placement-".concat(index)
    }, React.createElement("div", {
      className: isReserve ? 'pix-leg-number reserve' : 'pix-leg-number'
    }, isReserve ? 'Reserv' : "".concat(index + 1, ":a")), currSigns.map(participantNumber => React.createElement(ParticipantInfo, {
      hasMoreInfo: currSigns.length === 1,
      isReserve: isReserve,
      key: participantNumber,
      participantNumber: participantNumber,
      participants: participants
    })));
  };
  return React.createElement("div", {
    className: "racing-pix-bet-summary-holder pix-dialog-holder"
  }, React.createElement("div", {
    className: "pix-bet-summary-header"
  }, isHighFive && React.createElement(HighFiveLogo, null)), React.createElement("div", {
    className: "pix-bet-summary-sub-header"
  }, "".concat(date, " ").concat(time, ", ").concat(trackName, ", Lopp ").concat(raceNumber)), React.createElement("div", {
    className: "race-name"
  }, raceName), React.createElement("div", {
    className: "pix-bet-summary-list"
  }, racingSigns.map(_turnSignsIntoListItem)));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponRacing', CouponRacing);

 })(window);